import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { API } from "../lib/api";
import { useStore } from "../lib/store";
import { Monogram } from "../components/site/Logo";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { clearCart } = useStore();
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sessionId || !API) { setState("error"); return undefined; }
    let tries = 0;
    let timer;
    let alive = true;
    const poll = async () => {
      try {
        const res = await axios.get(`${API}/payments/status/${sessionId}`);
        if (!alive) return;
        if (res.data?.payment_status === "paid") { setState("paid"); clearCart(); return; }
        if (res.data?.status === "expired") { setState("error"); return; }
      } catch { /* retry */ }
      tries += 1;
      if (tries < 12) timer = setTimeout(poll, 2000);
      else if (alive) setState("timeout");
    };
    poll();
    return () => { alive = false; clearTimeout(timer); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  return (
    <main data-testid="payment-success-page" className="mx-auto flex max-w-2xl flex-col items-center px-5 py-28 text-center">
      <Monogram className="h-28 w-28 text-[13px]" />
      {state === "checking" && <p className="mt-10 flex items-center gap-3 font-display text-2xl italic"><Loader2 className="h-5 w-5 animate-spin" /> Confirming your order…</p>}
      {state === "paid" && (
        <>
          <h1 data-testid="payment-success-heading" className="mt-10 font-script text-6xl sm:text-7xl">Thank you, darling</h1>
          <p className="mt-4 text-plum/80">Your payment was successful. Your little luxuries are on their way.</p>
        </>
      )}
      {(state === "timeout" || state === "error") && (
        <>
          <h1 className="mt-10 font-display text-4xl italic">We're still confirming your payment</h1>
          <p className="mt-4 text-plum/80">If you completed checkout, you'll receive a receipt from Stripe shortly.</p>
        </>
      )}
      <Link to="/shop" data-testid="payment-continue-button" className="btn-luxe mt-10">Continue shopping</Link>
    </main>
  );
}

export function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="mx-auto max-w-2xl px-5 py-32 text-center">
      <h1 className="font-script text-6xl">Checkout cancelled</h1>
      <p className="mt-4 text-plum/80">No worries, your bag is still waiting for you.</p>
      <Link to="/cart" data-testid="payment-back-to-cart" className="btn-luxe mt-8">Back to bag</Link>
    </main>
  );
}
